;(function () {
	// ! snowbulletin currently supports only italian language
	if (WC?.idLingua === 1 && [23, 24, 42].indexOf(WC?.idMenu) > -1) {
		printBanner()
	} else {
		return
	}

	function printBanner() {
		const logo = `/images/snowbulletin/logo.svg`
		const image = `/images/snowbulletin/banner-snowbulletin.jpg`

		const el = document.createElement('div')
		el.classList.add('banner-snowbulletin')
		el.classList.add('dkreset')
		el.href = mL('url')
		el.innerHTML = /* html */ `
			<div class="banner-snowbulletin__content">
				<img src="${logo}" alt="${mL('imageAlt')}" class="banner-snowbulletin__logo">
				<p class="banner-snowbulletin__title">${mL('title')}</p>
				<p class="banner-snowbulletin__subtitle">${mL('subtitle')}</p>
				<div class="banner-snowbulletin__cta banner-snowbulletin-cta">
					<a href="${mL('url')}" class="banner-snowbulletin-cta__link">
						<span class="banner-snowbulletin-cta__text">${mL('ctaText')}</span>
						<span class="banner-snowbulletin-cta__icon material-icons">arrow_forward</span>
					</a>
				</div>
			</div>
		`

		const target = document.querySelector('.body-page .riquadro #content')
		if (target && target.querySelector('.article-disclaimers')) {
			target.insertBefore(el, target.querySelector('.article-disclaimers'))
		}
	}

	function mL(string) {
		const data = {
			url: {
				it: '/it/neve/',
			},
			title: {
				it: 'Bollettino neve e piste da sci',
			},
			subtitle: {
				it: 'Informazioni aggiornate direttamente dai gestori degli impianti',
			},
			imageAlt: {
				it: 'Asiago.it Bollettino Neve Logo',
			},
			ctaText: {
				it: 'Piste aperte',
			},
		}

		return data[string][WC.lang.substr(0, 2)]
	}
})()
